import { useEffect, useState } from 'react';

import { Divider, HStack, Text, VStack } from '@chakra-ui/react';
import { Sheet } from 'react-modal-sheet';

import { t } from 'i18next';
import { getUserLocale } from '../../utils/getUserLocale';
import PrimaryButton from '../buttons/PrimaryButton';
import PriamryCheckBox from '../checkbox/PriamryCheckBox';

export default function BaseAgreementBottomSheet({
  isOpen,
  onAgreementClick,
  title,
  description,
  buttonText = t('introPage.startButton'),
  transparentBackground = false
}) {
  const [isAgreeAll, setIsAgreeAll] = useState(false);
  const [isNotChild, setIsNotChild] = useState(false);
  const [termAndPrivacy, setTermAndPrivacy] = useState(false);
  const [marketingAgreement, setMarketingAgreement] = useState(false);

  useEffect(() => {
    // Check if all child checkboxes are checked
    const allChecked = isNotChild && termAndPrivacy && marketingAgreement;

    // Set the state of the parent checkbox accordingly
    setIsAgreeAll(allChecked);
  }, [isNotChild, termAndPrivacy, marketingAgreement]);

  const isRequiredAllChecked = () => {
    return termAndPrivacy && isNotChild;
  };

  const onClickButton = () => {
    if (!isRequiredAllChecked()) {
      return;
    }
    onAgreementClick(!isNotChild, marketingAgreement);
  };

  const handleAgreeAllToggle = (checked) => {
    setIsAgreeAll(checked);
    setIsNotChild(checked);
    setTermAndPrivacy(checked);
    setMarketingAgreement(checked);
  };

  return (
    <div className="h-[120px]">
      <Sheet isOpen={isOpen} disableDrag={true} onClose={() => {}} detent="content">
        <Sheet.Container
          className="!bg-backgroundElevated-light dark:!bg-backgroundElevated-dark"
          style={{
            paddingLeft: '20px',
            paddingRight: '20px',
            borderTopLeftRadius: '20px',
            borderTopRightRadius: '20px',
            boxShadow: '0px -6px 54px 0px rgba(0,0,0,0.13)'
          }}
        >
          <Sheet.Header className="pt-[19px] pb-[16px]">
            {title && (
              <Text
                fontWeight={600}
                fontSize={'20px'}
                marginTop={'10px'}
                paddingRight={'36px'}
                wordBreak={'auto-phrase'}
              >
                {t('agreements.baseAgreementBottomSheetTitle')}
              </Text>
            )}
            {description && (
              <Text
                fontWeight={400}
                fontSize={'14px'}
                marginTop={'7px'}
                marginBottom={'20px'}
                paddingRight={'36px'}
                wordBreak={'auto-phrase'}
              >
                {description}
              </Text>
            )}
            <HStack>
              <PriamryCheckBox
                size={'lg'}
                isChecked={isAgreeAll}
                onChanged={(checked) => handleAgreeAllToggle(checked)}
              />
              <Text
                fontSize={'17px'}
                fontWeight={600}
                className="text-main-light-1 dark:text-main-dark-1"
              >
                {t('agreements.baseAgreementBottomAgreeAllButton')}
              </Text>
            </HStack>
            <Divider className="py-[7px]" />
          </Sheet.Header>
          <Sheet.Content className="py-1" disableDrag={true}>
            <VStack align={'flex-start'} spacing={2.5}>
              <HStack>
                <PriamryCheckBox
                  isChecked={isNotChild}
                  onChanged={(checked) => setIsNotChild(checked)}
                />
                <Text
                  fontSize={'15px'}
                  fontWeight={400}
                  className="text-main-light-1 dark:text-main-dark-1"
                >
                  {t('agreements.baseAgreementChangeAbove14')}
                </Text>
              </HStack>
              <HStack>
                <PriamryCheckBox
                  isChecked={termAndPrivacy}
                  onChanged={(checked) => setTermAndPrivacy(checked)}
                />
                <HStack spacing={0.5}>
                  <Text
                    fontSize={'15px'}
                    fontWeight={400}
                    className="text-main-light-1 dark:text-main-dark-1"
                  >
                    {t('agreements.baseAgreementRequiredCheckBox')}
                  </Text>

                  <a
                    href={`/fanhearts?path=terms&category=terms_of_service&locale=${getUserLocale()}`}
                  >
                    <Text
                      fontSize={'15px'}
                      fontWeight={400}
                      className="text-pure-black dark:text-pure-white"
                      as="u"
                    >
                      {t('agreements.baseAgreementRequiredAgreement')}
                    </Text>
                  </a>
                </HStack>
              </HStack>
              <HStack>
                <PriamryCheckBox
                  isChecked={marketingAgreement}
                  onChanged={(checked) => setMarketingAgreement(checked)}
                />
                <HStack spacing={0.5}>
                  <Text
                    fontSize={'15px'}
                    fontWeight={400}
                    className="text-main-light-1 dark:text-main-dark-1"
                  >
                    {t('agreements.baseAgreementOptionalCheckBox')}
                  </Text>
                  <a
                    href={`/fanhearts?path=terms&category=marketing_consent&locale=${getUserLocale()}`}
                  >
                    <Text
                      fontSize={'15px'}
                      fontWeight={400}
                      className="text-pure-black dark:text-pure-white"
                      as="u"
                    >
                      {t('agreements.baseAgreementPromotionalAgreement')}
                    </Text>
                  </a>
                </HStack>
              </HStack>
              <div style={{ marginTop: '25px', width: '100%', marginBottom: '4px' }}>
                <PrimaryButton
                  text={buttonText}
                  onClick={() => onClickButton()}
                  width={'100%'}
                  minHeight={'52px'}
                  paddingX={'24px'}
                  paddingY={'16px'}
                  fontSize={'17px'}
                  disabled={!isRequiredAllChecked()}
                />
              </div>
            </VStack>
          </Sheet.Content>
        </Sheet.Container>
        <Sheet.Backdrop
          style={transparentBackground ? { backgroundColor: 'transparent' } : {}}
          onClick={() => {}}
        />
      </Sheet>
    </div>
  );
}
